module.exports = __webpack_public_path__ + "static/media/IIML-gainon_logo.svg.e3fe0024.png";